import "../../App.css";
import "../../styles/tabStyle.css";
import "../../styles/login.css";
import Sidebar from "../Sidebar";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Table from "../Table";
import UserTab from "../UserTab";
import Parametros from "../Parametros";
import CurrentUser from "../CurrentUser";
import EliminarElemento from "../EliminarElemento";

function ResultadosCarga(props) {
  const [usuario, setUsuario] = useState(CurrentUser.user);
  const [formBuscar, setFormBuscar] = useState({
    type_load: null,
    date_upload: null,
    user: null,
    result: null,
  });
  const [paginacionState, setPaginacionState] = useState({
    limit: 5,
    skip: 1,
  });
  const [paginas, setPaginas] = useState(0);
  const [update, setUpdate] = useState(false);
  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      let response = await fetch(
        Parametros.urlApi + "uploads_items/?skip=1&limit=5",
        {
          method: "POST",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formBuscar),
        }
      );
      let responseJson = await response.json();
      setResultadosState(responseJson.data);
      setPaginas(responseJson.n_pages);
      let responseTipo = await fetch(
        Parametros.urlApi + "uploads/?skip=1&limit=100",
        {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      let responseJsonTipo = await responseTipo.json();
      setTipoCarga(responseJsonTipo);
      let responseUsuarios = await fetch(
        Parametros.urlApi + "users/?skip=1&limit=100",
        {
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      let responseJsonUsuarios = await responseUsuarios.json();
      setUsuariosState(responseJsonUsuarios);
      setInitialized(true);
    };
    fetchData();
  }, [formBuscar, usuario.key]);

  const [tipoCarga, setTipoCarga] = useState([]);
  // eslint-disable-next-line
  const [resultadosState, setResultadoState] = useState([
    "pendiente",
    "cargado",
    "fallido",
  ]);
  const [usuariosState, setUsuariosState] = useState([]);

  const [resultadoState, setResultadosState] = useState([]);

  let handleStageForm = (event) => {
    setFormBuscar({
      ...formBuscar,
      [event.target.name]: event.target.value,
    });
  };
  useEffect(() => {
    if (initialized) {
      enviarFormulario();
    }
  }, [paginacionState]);

  let enviarFormulario = async (event, fromButton = false) => {
    if (event) {
      event.preventDefault();
    }

    let formToSend = {};

    for (const key in formBuscar) {
      if (formBuscar[key] === "") {
        formToSend[key] = null;
      } else {
        formToSend[key] = formBuscar[key];
      }
    }
    let skip;
    if (fromButton) {
      skip = 1;
      setPaginacionState({ ...paginacionState, skip: 1 });
      setUpdate(!update);
    } else {
      skip = paginacionState.skip;
    }
    let response = await fetch(
      Parametros.urlApi +
        `uploads_items/?skip=${skip}&limit=${paginacionState.limit}`,
      {
        method: "POST",
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formToSend),
      }
    );
    let responseJson = await response.json();
    setResultadosState(responseJson.data);
    setPaginas(responseJson.n_pages);
  };
  function downloadfile(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    // the filename you want
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
  const download = async (masiveUploadId, kind, displayName) => {
    let response = await fetch(
      Parametros.urlApi +
        `get_upload_item/${masiveUploadId}?kind=${kind}`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + usuario.key,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    if (!response.ok) {
      return;
    }
    response.blob().then((blob) => downloadfile(blob, displayName));
  };
  return (
    <div className="App">
      <Sidebar tipo="1"></Sidebar>
      <br />

      <UserTab nombre={"Resultados Carga"}></UserTab>
      <div className="container">
        <form
          id="formularioBusqueda"
          onSubmit={(e) => enviarFormulario(e, true)}
        >
          <div className="col-md-4">
            <h5>Tipo de carga</h5>
            <select
              name="type_load"
              onChange={handleStageForm}
              className="form-control"
            >
              <option value={""}>Todos</option>
              {tipoCarga?.map((item, index) => {
                return (
                  <option key={item.upload_type_id} value={item.upload_type_id}>
                    {item.name}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="col-md-4">
            <h5>Fecha de carga</h5>
            <input
              type="date"
              onChange={handleStageForm}
              name="date_upload"
              className="form-control"
            ></input>
          </div>

          <div className="col-md-4">
            <h5>Usuarios</h5>
            <select
              name="user"
              onChange={handleStageForm}
              className="form-control"
            >
              <option value={""}>Todos</option>
              {usuariosState?.map((item, index) => {
                return (
                  <option key={item.user_id} value={item.username}>
                    {item.username}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="col-md-4">
            <h5>Resultado</h5>
            <select
              name="result"
              onChange={handleStageForm}
              className="form-control"
            >
              <option value={""}>Todos</option>
              {resultadosState &&
                resultadosState?.map((item, index) => {
                  return (
                    <option key={index} value={item}>
                      {item}
                    </option>
                  );
                })}
            </select>
          </div>

          <div className="col-md-4">
            <br />
            <button
              type="submit"
              value="Submit"
              style={{ margin: "14px 0px" }}
              id="btnBuscar"
              className="form-control button brEdit btn-primary"
            >
              Buscar
            </button>
          </div>
        </form>

        <div className="col-md-12" style={{ width: "100%" }}>
          <Table
            key={update}
            type={1}
            paginationBelow={true}
            paginas={paginas}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            elementos={[
              "Fecha",
              "Resultado",
              "Documento de carga",
              "Resultado de carga",
              "Tipo carga",
              "Usuario",
            ]}
          ></Table>
          <table className="table table-bordered table-responsive" id="myTable">
            <Table
              type={2}
              id={1}
              elementos={[
                "Fecha",
                "Resultado",
                "Documento de carga",
                "Resultado de carga",
                "Tipo carga",
                "Usuario",
              ]}
            ></Table>
            <tbody className="ajusteTabladata">
              {resultadosState?.length > 0 &&
                resultadoState?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td> {item.masive_upload_id}</td>
                      <td> {item.date_upload}</td>
                      <td> {item.result}</td>
                      <td
                        className="link"
                        onClick={() => download(item.masive_upload_id, "input", item.input_url)}
                      >
                        {item.input_url}
                      </td>
                      <td
                        className="link"
                        onClick={() =>
                          download(item.masive_upload_id, "errors", item.output_url)
                        }
                      >
                        {item.output_url}
                      </td>
                      <td> {item.upload_type}</td>
                      <td> {item.user}</td>
                      <td>
                        <EliminarElemento
                          endpoint={`masive_upload/${item.masive_upload_id}`}
                          onSuccess={() => enviarFormulario()}
                        />
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          <Table
            type={3}
            paginas={paginas}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
        </div>
      </div>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
    </div>
  );
}

export default withRouter(ResultadosCarga);
